import { useContext, useMemo } from 'react';
import GlobalContext, { DefaultGlobalContextValue } from '../../common/context/global';

export default function useGeoIpInfo() {
  const { geoIpInfo = DefaultGlobalContextValue.geoIpInfo } = useContext(GlobalContext);
  return useMemo(() => geoIpInfo, [geoIpInfo]);
}
